// Illustrative photography. Alt text describes the scene only and never
// claims the people or vehicles shown are Swift Move and Clean's own.
export const SITE_PHOTOS = {
  hero: {
    src: '/images/hero-sunset-move.webp',
  },
  banner: {
    src: '/images/banner-sunset-loading.webp',
  },
  residentialMoving: {
    src: '/images/residential-moving.webp',
    width: 1284,
    height: 963,
    alt: 'Illustration of movers carrying a sofa and boxes beside a moving truck outside a townhome',
  },
  packing: {
    src: '/images/packing-kitchen.webp',
    width: 1284,
    height: 963,
    alt: 'Illustration of two people wrapping dishes in bubble wrap while packing a kitchen',
  },
  residentialCleaning: {
    src: '/images/residential-cleaning.webp',
    width: 1284,
    height: 647,
    alt: 'Illustration of two cleaners wiping a kitchen counter and vacuuming an empty living room',
  },
  commercialCleaning: {
    src: '/images/commercial-cleaning.webp',
    width: 1262,
    height: 946,
    alt: 'Illustration of two cleaners washing the glass doors of a retail storefront',
  },
};

export const GALLERY_PHOTOS = [
  {
    src: '/images/gallery-1.webp',
    width: 627,
    height: 410,
    alt: 'Illustration of two movers carrying a wooden chest past a suburban home at sunset',
  },
  {
    src: '/images/gallery-2.webp',
    width: 626,
    height: 410,
    alt: 'Illustration of movers unloading boxes from a truck beside a row of storage units at dusk',
  },
  {
    src: '/images/gallery-3.webp',
    width: 368,
    height: 420,
    alt: 'Illustration of two movers carrying a wooden chest down a tree-lined street',
  },
  {
    src: '/images/gallery-4.webp',
    width: 438,
    height: 420,
    alt: 'Illustration of moving trucks parked in front of a brick building with a clock tower',
  },
  {
    src: '/images/gallery-5.webp',
    width: 627,
    height: 405,
    alt: 'Illustration of a quiet neighborhood street at golden hour',
  },
  {
    src: '/images/gallery-6.webp',
    width: 626,
    height: 405,
    alt: 'Illustration of a person loading boxes into a truck between rows of storage units',
  },
];
